import React from 'react';

const OutlineImportIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5003 18.9587H7.50033C2.97533 18.9587 1.04199 17.0253 1.04199 12.5003V7.50033C1.04199 2.97533 2.97533 1.04199 7.50033 1.04199H12.5003C17.0253 1.04199 18.9587 2.97533 18.9587 7.50033V12.5003C18.9587 17.0253 17.0253 18.9587 12.5003 18.9587ZM7.50033 2.29199C3.65866 2.29199 2.29199 3.65866 2.29199 7.50033V12.5003C2.29199 16.342 3.65866 17.7087 7.50033 17.7087H12.5003C16.342 17.7087 17.7087 16.342 17.7087 12.5003V7.50033C17.7087 3.65866 16.342 2.29199 12.5003 2.29199H7.50033Z"
      fill="currentColor"
    />
    <path
      d="M9.99987 12.7167C9.84154 12.7167 9.6832 12.6583 9.5582 12.5333L7.0582 10.0333C6.81654 9.79166 6.81654 9.39167 7.0582 9.15C7.29987 8.90833 7.69987 8.90833 7.94153 9.15L9.99987 11.2083L12.0582 9.15C12.2999 8.90833 12.6999 8.90833 12.9415 9.15C13.1832 9.39167 13.1832 9.79166 12.9415 10.0333L10.4415 12.5333C10.3165 12.6583 10.1582 12.7167 9.99987 12.7167Z"
      fill="currentColor"
    />
    <path
      d="M10 12.7165C9.65833 12.7165 9.375 12.4331 9.375 12.0915V5.4248C9.375 5.08314 9.65833 4.7998 10 4.7998C10.3417 4.7998 10.625 5.08314 10.625 5.4248V12.0915C10.625 12.4415 10.3417 12.7165 10 12.7165Z"
      fill="currentColor"
    />
    <path
      d="M9.99971 15.1921C8.24138 15.1921 6.47471 14.9088 4.79971 14.3505C4.47471 14.2421 4.29971 13.8838 4.40804 13.5588C4.51638 13.2338 4.86637 13.0505 5.19971 13.1671C8.29971 14.2005 11.708 14.2005 14.808 13.1671C15.133 13.0588 15.4914 13.2338 15.5997 13.5588C15.708 13.8838 15.533 14.2421 15.208 14.3505C13.5247 14.9171 11.758 15.1921 9.99971 15.1921Z"
      fill="currentColor"
    />
  </svg>
);

export default OutlineImportIcon;
